import { atom } from 'recoil'

export const BrushSizeAtom = atom<number>({
  key: 'brush-size',
  default: 3,
})
